<template>
  <div>
    <Banner type="small" img="partners-banner.jpg">
      <h2
        class="banner__title--medium banner__title--separator text--white text--muli text--extrabold mb--x3"
      >
        PRODUCTS
      </h2>
      <p class="banner__title--text text--white text--normal m--none">
        In order to provide our customers with the best and most advanced
        technological solutions, we are in continuous development of alliances
        and representations of the best manufacturing companies for the oil and
        gas industry.
      </p>
    </Banner>
    <DcSection class="back--grey--c">
      <div class="container">
        <Title title="products" color="2d2d2d" position="center" />
        <div ref="products" class="grid products">
          <Product image="products/1.jpg" title="Power Plants">
            <p class="text--small mb--x1">
              SPU Stationary Medium Speed Generator Sets define reliability and
              efficiency. Medium speed, higher efficiency, excellent
              reliability, lower operational and maintenance cost and lower
              emissions are key design features of the SPU line of generator
              sets.
            </p>
            <p class="text--small">
              SPU generator sets are designed specifically for heavy duty
              industrial and utility power applications. The units are the
              optimal choice for continuous or peaking requirements from 1500
              Kilowatts to 100 Megawatts or more. Each SPU Generator Set is
              packaged on a single steel skid and include a remote mount
              radiator, silencer and auto paralleling switchgear with vacuum
              breaker as well as remote &amp; skid mounted advanced
              engine/generator controls and alarm panels.
            </p>
          </Product>
          <Product
            class="image__contain"
            image="products/2.jpg"
            title="Portable Power on Demand"
          >
            <p class="text--small mb--x1">
              MPU generator sets are rugged in design for service in heavy duty
              industrial and utility power applications. Generator Sets offer
              continuous output ratings of 1500kW, 2000kW, 2500kW &amp; 2500kW,
              3000kW &amp; 3950kW and with the combination we can to reach to
              100 Megawatts or more.
            </p>
            <p class="text--small">
              These heavy duty generator sets are designed for critical need
              power requirements in harsh &amp; remote environments and the EMD
              medium speed engine power plant offers the lowest operating and
              maintenance cost in the industry - period.
            </p>
            <p></p>
          </Product>
          <Product image="products/3.jpg" title="Solar Panel">
            <ul>
              <List text="Monocrystalline Silicon" />
              <List text="Polycrystalline Silicon" />
              <List text="Copper Indium Gallium Selenide (CIS/CIGS)" />
              <List text="Cadmium Telluride (CdTe)" />
              <List text="Amorphous Silicon (a-Si)" />
              <List text="Thin-Film" />
              <List text="String Ribbon" />
            </ul>
          </Product>
          <Product image="products/4.jpg" title="Solar Light LED">
            <p class="text--small mb--x1">
              Solar Light Led is a new generation of smart street LED luminaire
              which is widely used in street, patio, garden, pathway, park, etc.
            </p>
            <p class="text--small mb--x1">
              It is made up of solar panel, battery, light source, controller,
              and PIR sensor, it can work intelligently without a wire and
              electricity.
            </p>
            <h4 class="mb--x1">Features</h4>
            <ul class="mb--x1">
              <List text="Completely Standalone" />
              <List
                text="Self-contained Solar Street Light System/ Solar Flood Light/ Solar Flag Pole Light, Replacement
Landscaping."
              />
              <List text="No Electric Meter" />
              <List text="No Electric Usage and Demand Charges" />
              <List
                text="Long Life Span – LED light life span more than 50,000 hours. Save on light bulb replacement,
maintenance and installation costs."
              />
              <List
                text="High Quality – Lithium batteries are manufactured to high standards for high power applications,
safety, strong thermal stability, tolerance to abuse, high current rating and 1,000 cycle life. Lithium
batteries are recyclable"
              />
            </ul>
            <ul class="product__feature">
              <li>IP 65 Water Proof</li>
              <li>12 Hour Autonomy</li>
              <li>Camera Integrated</li>
            </ul>
          </Product>
          <Product image="products/5.jpg" title="Submersible Solar Pumps">
            <p class="text--small mb--x1">
              Solar Pumping systems considering the need of water in remote
              areas with NO power distribution &amp; understanding the very
              importance of using Green Energy. Solar Pumps are developed with
              different materials of construction and reasonably good range and
              meet customer requirement. Both Screw and Centrifugal type Solar
              Pumps are available with different head and flow range. These
              Pumps are Oil filled AC / DC (up to 1000 W) motors. Every
              component of the pumping system is designed &amp; manufactured to
              deliver sustained high efficiency. Available until 300 meter.
            </p>
            <h4 class="mb--x1">Features</h4>
            <ul class="mb--x1">
              <List text="More longevity &amp; Hygiene" />
              <List text="High operating efficiency" />
              <List text="Floating impeller design prevents sand blockages" />
              <List text="Easy to dismantle &amp; repair" />
              <List text="Rigid construction" />
              <List text="Highly durable" />
              <List text="Can handle more up thrust loads" />
              <List text="NEMA mounting standard" />
            </ul>
            <ul class="product__feature">
              <li>Pump</li>
              <li>Pool pump</li>
            </ul>
          </Product>
          <Product image="products/6.jpg" title="Solar Power Bank">
            <p class="text--smal mb--x1">
              SOLAR POWER BANK is the ideal energy storage solution for whenever
              and wherever you need power the most. Similar to a big battery
              bank, it’s packed with all the latest technology built to
              withstand harsh environments and housed in a 40-foot steel
              container. The stores electricity from any source – grid power or
              local output from solar panels, wind turbines or generator sets –
              ready to deliver power at the flick of a switch.
            </p>
            <p class="text--smal mb--x1">
              Whether you need a fully autonomous off-grid facility or simply
              want to manage your power supplies more efficiently – such as
              engaging in peak shaving, load-shifting or grid stabilization –
              the power bank is a scalable, plug-and-play solution that provides
              reliable power, anytime and anywhere.
            </p>
            <ul class="product__feature">
              <li>Container Energy Storage</li>
              <li>Scalable in size</li>
            </ul>
          </Product>
          <Product image="products/7.jpg" title="Permanent Magnet Motor">
            <p class="text--small mb--x1">
              Low-voltage motors cover a wide range of motors from 0.09 KW up to
              5 MW. They conform to IEC and NEMA standards and they are highly
              efficient.
            </p>
            <p class="text--small">
              Motor efficiency is above IE4 grade (ultra high efficiency: above
              GB1 grade). Due to the same seat number design with the
              asynchronous motor, also the installation size is the same, which
              can be changed easily.
            </p>
          </Product>
          <Product
            class="image__contain"
            image="products/8.jpg"
            title="PCP Drive Head"
          >
            <p class="text--small mb--x1">
              The Rod Driven System for progressive cavity pump (PCP) in that
              the downhole positive displacement rotary gear pump is driven by a
              surface top drive system connected by a rod string. The rotation
              of the rods by means of an electric or hydraulic motor at surface
              causes the fluid contained in the gear pump to flow upward.
            </p>
            <p class="text--small">
              Listed are the operating features and advantages of the gear pump
              over both PCP and other reciprocating rod-lift systems.
            </p>
          </Product>
          <Product image="products/9.jpg" title="VFD Rod Pump">
            <p class="text--small mb--x1">
              The Schneider Electric™ Altivar™ 930 variable frequency drive
              (VFD), is the ultimate solution in Sucker Rod Pump control.
            </p>
            <p class="text--small">
              Whether deployed as a stand-alone beam pump drive, pump off
              controller, or as a part of an enterprise level oil/gas field
              strategy, it can be tailored to fit all your needs from the basic
              to the most complex.
            </p>
          </Product>
          <Product image="products/10.jpg" title="API 610 PUMPS">
            <p class="text--small">
              Centrifugal API 610 / ISO 13709 pumps for petroleum refinery, gas
              processing, oil processing, petrochemical, hydrocarbon and crude
              oil pipeline, offshore installations (platform) and aviation jet
              fueling.
            </p>
          </Product>
          <Product image="products/11.jpg" title="ESP Variable Speed Drives">
            <p class="text--small mb--x1">
              The variable-speed drive (VSD) is a highly sophisticated
              switchboard-motor controller. A VSD performs three distinct
              functions. It varies the capacity of the ESP by varying the motor
              speed, protects downhole components from power transients, and
              provides “soft-start” capability. A VSD changes the capacity of
              the ESP by varying the motor speed. By changing the voltage
              frequency supplied to the motor and thus motor rpm, the capacity
              of the pump is also changed in a linear relationship. This applies
              to both long-range reservoir changes and short-term transients
              such as those associated with high-GOR wells. This may eliminate
              the need to change the capacity of a pump to match changing well
              conditions, or it may mean longer run life by preventing cycling
              problems. This capability is also useful in determining the
              productivity of new wells by documenting pressure and production
              values over a range of drawdown rates. The change in voltage
              frequency can be made manually or automatically. The VSD can
              operate automatically in a “closed loop” mode with a programmable
              controller and pressure-sensing instrument.
            </p>
            <p class="text--small mb--x1">
              The VSD also protects the downhole motor from poor-quality
              electricity power.
            </p>
            <p class="text--small">
              The soft-start capability of a VSD provides two major benefits.
              First, it reduces the startup drain on the power system. Second,
              the strain on the pump shaft (and its associated components) is
              significantly reduced when compared with that of a standard start.
              This capability is valuable in gassy or sandy wells. In some
              cases, slowly ramping a pump up to operating speed may avoid pump
              damage.
            </p>
          </Product>
          <Product image="products/12.jpg" title="Heat Shrinkable Sleeve">
            <p class="text--small mb--x1">
              Heat Shrinkable Sleeve is mainly used in coating the weld joint of
              buried steel pipeline and insulated pipeline, especially for
              3-Layer coated oil and gas pipeline project need dry epoxy primer
              installation application
            </p>
            <p class="text--small mb--x1">
              It forms excellent adhesion with the surface of steel pipeline,
              PE-coating; meanwhile, it forms a continuous and firm
              anti-corrosive system with the surface of the pipeline.
            </p>
            <p class="text--small">
              It have strong adaptive capacity to environment and good
              resistance to mechanical damage. It also has good resistance to
              liquid pressure and bacterium, mildew and other chemical
              corrosion.
            </p>
          </Product>
          <Product image="products/13.jpg" title="OCTG">
            <p class="text--small mb--x1">
              Oil Country Tubular Goods are used both onshore and offshore. Each
              wellbore proceeds in multiple phases, during which.
            </p>
            <ul>
              <List text="Drill pipe" />
              <List text="casing (lines the wellbore)" />
              <List
                text="Tubing (delivery or production tubes that transport the oil and gas to the surface)"
              />
            </ul>
          </Product>
          <Product image="products/14.jpg" title="Globe Control Valve">
            <h4 class="mb--x1">Standard:</h4>
            <ul class="mb--x1">
              <List title="Design:" text="ASME-B-16.34, SFS EN 12516-2" />
              <List title="F/F:" text="ISA 75.08.01, B16.10" />
              <List title="Testing:" text="FCI70-2" />
              <List
                title="END CONNECTION:"
                text="FLANGE-B16.5,B16.47, B2220, IS 6392,EN1092-1
SCREWED &amp; SOCKET-B16.11
BUTTWELD-B16.25"
              />
            </ul>
            <ul class="product__feature">
              <li>Single Seated</li>
              <li>Double Seated</li>
              <li>Three Way</li>
              <li>Angle</li>
            </ul>
          </Product>
          <Product image="products/15.jpg" title="Ball Valve">
            <h4 class="mb--x1">Standard:</h4>
            <ul class="mb--x1">
              <List title="Design:" text="API-6D/ASME-B-16.34" />
              <List title="F/F:" text="API-6D/ASME-B-16.10" />
              <List title="Testing:" text="API-6D/API-598/ISO-5208/EN-12266" />
              <List title="Fire Safe:" text="API-607/API-6Fa" />
              <List title="Anti static Test:" text="API6D" />
              <List title="Cavity Relief Test:" text="API6D" />
              <List
                title="END CONNECTION:"
                text="FLANGE-B16.5,B16.47,EN1092-1, BUTTWELD-B16.25"
              />
            </ul>
            <ul class="product__feature">
              <li>Floating Ball</li>
              <li>Trunion</li>
              <li>Top Entry</li>
              <li>Fully Welded</li>
            </ul>
          </Product>
          <Product image="products/16.jpg" title="Butterfly Valve">
            <h4 class="mb--x1">Standard:</h4>
            <ul class="mb--x1">
              <List title="Design:" text="BS-5155/API-609/ASME-B-16.34" />
              <List title="F/F:" text="BS-5155 /API-609" />
              <List title="Proof of design Test:" text="AWWA-C-504" />
              <List
                title="Testing:"
                text="BS-6755 part-1 / API-598/ANSI-FCI-70-2"
              />
              <List
                title="END CONNECTION:"
                text="FLANGE/WAFER-B16.5,B16.47, EN1092-1
SCREWED &amp; SOCKET-B16.11"
              />
            </ul>
            <ul class="product__feature">
              <li>Double Offset</li>
              <li>Triplex Offset</li>
              <li>Resilient Seated</li>
              <li>Clearance Type</li>
              <li>AWWA Butterfly Valve</li>
            </ul>
          </Product>
          <Product image="products/17.jpg" title="Special Control Valve">
            <ul class="product__feature">
              <li>Metal Housed Globe Teflon</li>
              <li>Flush Bottom Valve</li>
              <li>V - Ball Valve</li>
              <li>Multi-Port Valve</li>
            </ul>
          </Product>
          <Product image="products/18.jpg" title="Mechanical Seals">
            <ul>
              <List text="API 682 Seals Type A, Type B, Type C" />
              <List text="Multi Spring Seals" />
              <List
                text="
Single Coild Spring Seal"
              />
              <List text="Single Spring Seals" />
              <List text="Conical Spring Seals" />
              <List text="Rubber Bellow Seals" />
              <List text="Wave Spring Seals" />
              <List text="PTFE Bellow Seals" />
              <List text="Metal Bellow Seals" />
              <List text="Cartridge Seals" />
              <List
                text="Split Seals
"
              />
              <List text="Dry Running Seals" />
              <List text="Single and Double Agitator Seals" />
            </ul>
          </Product>
          <Product image="products/19.jpg" title="Casing Head">
            <p class="text--small mb--x1">
              The casing head ,a component connecting the casing to the wellhead
              assembly of various types and sizes ,is used to support the both
              the intermediate (protective) string and the production string
              ,and to seal up the annular space between the casings, thus
              providing a crossover connection for the installation of the bop
              ,the tubing head, the Christmas tree and other top wellhead
              components. It is also used to inject additional cement slurry or
              balance fluid, monitor the well sink, and execute other operations
              through both of the two bypass holes in the casing head body.
            </p>
            <p class="text--small mb--x1">
              The casing head ,which is of standard structure ,is fitted with a
              complete set of casing head hangers are available for choice
              according to different requirements of casing procedure and
              wellhead conditions. the top part of the body is API6B or API6BX
              flanged.
            </p>
            <p class="text--small">
              Options of casing head There are four options for the bottom
              connection of the casing head: API NPT box ,API CSG box,sow type
              and slip-type.
            </p>
          </Product>
          <Product
            image="products/20.jpg"
            title="Chemical Injection Line Tubing"
          >
            <p class="text--small mb--x1">
              Steel tubing is applied to umbilicals and chemical injection
              systems play an effective role in chemical storage and delivery at
              an optimizing flow assurance.
            </p>
            <p class="text--small mb--x1">
              Our tubing is characterized with integrity and quality to be
              specially used in subsea conditions in the industries of oil and
              gas extraction.
            </p>
            <p class="text--small mb--x1">
              We supplier of welded and cold drawn, welded and seamless tubing
              which are made from corrosion-resistant austenitic, duplex, super
              duplex stainless steels and nickel alloy grades. We have been
              specializing in manufacturing coiled tubing used in the oil and
              gas industry.
            </p>
            <h4 class="mb--x1">
              Available Alloy Grades for Chemical Injection Line Tubing:
            </h4>
            <ul class="mb--x1">
              <List text="Austenitic: S31603/316L" />
              <List text="Duplex: S31803/S32205/S32750" />
              <List text="Nickel alloy: N08825/N06625" />
            </ul>
            <h4 class="mb--x1">Stainless Steel Tube Norms:</h4>
            <ul class="mb--x1">
              <List text="ASTM A789 / ASME SA789 / EN10216-5" />
              <List
                text="
Coiled Tubing Process: TIG welded and cold drawn / Seamless and cold drawn"
              />
            </ul>
            <h4 class="mb--x1">Coiled Tubing Dimension:</h4>
            <ul class="mb--x1">
              <List
                text="Outside Diameter: 1/8’’ – 1/2’’ (3.175 mm – 12.7 mm)"
              />
              <List text="Coiled tubing length: up to 32,808 feet (10,000 m)" />
            </ul>
            <h4 class="mb--x1">Application: Control line:</h4>
            <ul class="mb--x1">
              <List text="Chemical injection line" />
              <List text="Electrical line" />
              <List text="Multi-line flat pack" />
              <List text="Hydraulic line" />
              <List text="Tubing encapsulated conductor" />
              <List text="Capillary tubing" />
            </ul>
          </Product>
          <Product image="products/21.jpg" title="Flexible Conduits">
            <p class="text--small mb--x1">
              The Liquatite® line includes nearly 50 varieties of flexible
              electrical conduits for contractors, OEMs, industrial maintenance
              and repair (MRO), government, utility and export users. Most
              flexible conduits are available and in stock. Product families
              include: Jacketed Metallic Conduit, Unjacketed Metallic Conduit,
              Nonmetallic Conduit, EMI/RFI Shielded Conduit, and Nylon-Corrlok
              Conduit.
            </p>
            <h4 class="mb--x1">
              Electrical Conduit Types:
            </h4>
            <ul class="">
              <List text="Jacketed Metallic" />
              <List text="EMI/RFI Shielded" />
              <List text="Nonmetallic" />
              <List text="Nylon/Corrlok" />
              <List text="Unjacketed Metallic" />
            </ul>
          </Product>
          <Product image="products/22.jpg" title="Gas Detectors &amp; Sensors">
            <p class="text--small mb--x1">
              Detectors specifically designed to monitor Carbone Dioxide (CO2),
              Hydrogen Sulfide (H2S), various combustible gases and toxic gases
              like Ammonia, Propane, Hexanes, Hydrogen Cyanide, Methanol and
              more, as well as detectors that monitor and sense oxygen
              deficiencies in the air.
            </p>
            <h4 class="mb--x1">
              The most commonly employed are:
            </h4>
            <ul class="mb--x1">
              <List text="Catalytic Bead: Combustible Gases" />
              <List
                text="Electrochemical for Toxic Gas Detection (Example: Ammonia, Hydrogen Sulfide, Sulfur Dioxide,
Carbon Monoxide"
              />
              <List text="Electrochemical for Oxygen Detection" />
              <List text="Nylon/Corrlok" />
              <List
                text='Metal Oxide Semiconductor (also called "Solid State")'
              />
              <List
                text="Non-dispersive Infrared (NDIR): Combustible Hydrocarbons"
              />
              <List text="Photoionization" />
            </ul>
            <p class="text--small">
              Mostly toxic gases are monitored and measured in parts per million
              (ppm) range while Oxygen is measured in percent volume.
              Combustible gases are generally measured as 0-100% of the lower
              explosive limit (LEL).
            </p>
          </Product>
          <Product image="products/23.jpg" title="Digital Pressure Gauges">
            <p class="text--small mb--x1">
              Safe Work Environment With Digital Electronic Gauges Operators in
              oilfields have dangerous jobs that involve higher pressure ranges,
              putting them in great jeopardy.
            </p>
            <p class="text--small mb--x1">
              We provide some of the world’s most popular digital pressure
              gauges for a variety of applications and markets. Included are
              intrinsically safe &quot;percent of reading&quot; gauges, process
              gauges, differential pressure gauges, panel mounted gauges, and
              gauges specifically designed for use in the maritime industry.
              Whether you’re looking for a pressure gauge with long battery life
              to mount in hard to reach locations, a pressure gauge to collect
              and store readings in the field in extreme conditions, or one that
              doesn’t require recalibration for up to three years, we have the
              perfect digital pressure gauge for you.
            </p>
            <p class="text--small mb--x1">
              High-quality digital electronic manometers with easily readable
              displays and practical additional functions.
            </p>
            <ul class="">
              <List
                title="Pressure Ranges < >"
                text="0...0,03 to 0...1000 bar"
              />
              <List title="Accuracy < >" text="± 0,05 %FS" />
              <List
                title="Total Error Band < >"
                text="± 0,05 %FS @ 0...50 °C"
              />
              <List title="Interfaces < >" text="RS485" />
              <List
                title="Special Characteristics < >"
                text="Precision of up to 0,01 %FS"
              />
            </ul>
          </Product>
          <Product image="products/24.jpg" title="Metering Dosing Pumps">
            <p class="text--small mb--x1">
              Dosing pump for suitable service conditions involving hazardous
              toxic, radioactive or poisonous liquid where product leakage is
              not at all permitted.
            </p>
            <p class="text--small mb--x1">
              The Range includes high precision positive displacement pump
              conforming to API 675. Typical applications for our pumps are
              useful for accurate dosing and mixing of acids, alcoholics,
              slurries, viscous liquids etc. Various capacity and pressure from
              2 – 15000 LPH. pump can be offered in Simplex, Duplex, Triplex and
              Multiple Heads, handling for different chemicals with a common
              Motor.
            </p>
            <p class="text--small">
              The pump discharge is variable while pump is running or at rest
              from Zero (0%) to full stroke (100%) by means of a precision
              machined Crank equipped with a stroke length adjustment mechanism.
              The Stroke of the pump controlled either Manually Wetted parts can
              be offered in S.S. 316 or 304, Carbon Steel, P.P. / Teflon / PVDF,
              Alloy 20, Hastalloy B or C. etc.
            </p>
            <h4 class="mb--x1">
              Applications:
            </h4>
            <p class="text--small">
              Diaphragm Type Pumps are used in Chemicals Plant, Fertilizer
              Plant, Water Treatment Plant, Soap Plant, Paper Industries,
              Pharmaceuticals Industries, Thermal Power Projects, and Plastic
              Industries.
            </p>
          </Product>
          <Product
            image="products/25.jpg"
            title=" Sucker Rods &amp; Downhole Pumps "
          >
            <p class="text--small">
              Dynamic Torque Anchor, Fiberglass rods, Gas Anchor, Gas
              Compressors, , Pump Anchor, Polished Rod Clamp, Rod Hook, Rod
              Rotator, Rod Scrapers and Guides, Replacement bearings, gears and
              pinions for most pumping units, , Sand Screens, Sinker Bars,
              Stuffing Box, Sucker rod elevators, Tubing rotator, Wheeled Rod
              Guides. Gas Engines, Gas Lift Mandrel, Pump Repair Shop and
              accessories.
            </p>
          </Product>
          <Product
            image="products/26.jpg"
            title="Spare Parts &amp; Rig Accessories"
          >
            <p class="text--small mb--x1">
              Parts and rig accessories are also available from us, sourced from
              various well-known US and China manufacturers:
            </p>
            <p class="text--small">
              Elevator Links &amp; Hooks, Depth and weight measuring, Diesel
              Engines, Drill Collars, Drill Pipes, Drilling Line, Workover Rig
              Pressure Gauges, Casing Head, Rotary Tables, Power Tong, Spiders,
              Swabbing tool, Tubing Elevator, Tubing Head, Wireline Unit, Tubing
              Hanger.
            </p>
          </Product>
        </div>
      </div>
    </DcSection>
    <DcSection class="back--white brands">
      <div class="container">
        <Title
          title="BRANDS"
          subtitle="OUR WORK WITH BEST"
          color="2d2d2d"
          position="center"
          margin="0 0 35px !important"
        />
        <div class="flex flex__center__center flex__evenly__center--tb">
          <ImageContent
            v-for="(pic, index) in pictures"
            :key="index"
            class="brand"
            :source="`products/brands/${pic}.png`"
          />
        </div>
      </div>
    </DcSection>
    <CallAction backgroundImage="call__contact.jpg" backgroundColor="#efdc30">
      <h2 class="title__section text--white mb--x3">
        HAVE A QUESTIONS OR HAVE A SPECIAL REQUEST?
      </h2>
      <p class="text--normal text--white text__content--normal  mb--x3">
        We are ready to help you. In fact, we promise to get back to you in less
        than 12 hours.
      </p>
      <NeButton routeLink="/contact" align="left">
        contact us for a quote
      </NeButton>
    </CallAction>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import Title from "@/components/NeTitle.vue";
import CallAction from "@/components/CallAction.vue";
import NeButton from "@/components/Button.vue";
import Product from "@/components/Product.vue";
import ImageContent from "@/components/ImageContent.vue";
import List from "@/components/List.vue";

import DcSection from "@/layouts/DcSection.vue";

export default {
  metaInfo: {
    title: "Products",
    meta: [
      {
        name: "description",
        hid: "description",
        content:
          "We are in continuous development of alliances and representations of the best manufacturing companies for the oil and gas industry."
      },
      // Open Graph
      { name: "og:title", content: "Products | Neuss Technical Services" },
      {
        name: "og:description",
        content:
          "We are in continuous development of alliances and representations of the best manufacturing companies for the oil and gas industry."
      },
      { name: "og:type", content: "website" },
      { name: "og:url", content: "https://www.neuss-ts.com/" },
      { name: "og:image", content: "https://davecastworks.com/meta_640.jpg" },
      // Twitter Card
      { name: "twitter:card", content: "summary" },
      { name: "twitter:site", content: "@neussts" },
      {
        name: "twitter:title",
        content: "Products | Neuss Technical Services"
      },
      {
        name: "twitter:description",
        content:
          "We are in continuous development of alliances and representations of the best manufacturing companies for the oil and gas industry."
      },
      {
        name: "twitter:image",
        content: "https://davecastworks.com/meta_640.jpg"
      },
      { name: "twitter:image:alt", content: "NeussTS Logo" }
    ]
  },
  name: "Products",
  components: {
    Banner,
    DcSection,
    Title,
    CallAction,
    NeButton,
    Product,
    ImageContent,
    List
  },
  data() {
    return {
      pictures: 29,
      windowWidth: window.innerWidth
    };
  },
  methods: {
    setParentStyle() {
      this.$refs.products.style.gridTemplateRows =
        this.windowWidth > 800 ? "8px" : "15px";
      this.$refs.products.style.gridAutoRows =
        this.windowWidth > 800 ? "8px" : "15px";
    },
    setRows() {
      console.log("2");
      this.$refs.products.children.forEach(element => {
        let dividerNumber = this.windowWidth > 800 ? 8 : 15;
        element.style.gridRowEnd = `span ${Math.ceil(
          element.offsetHeight / dividerNumber
        ) + 4}`;
      });

      this.setParentStyle();
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    /*if (this.windowWidth > 595) {
      setTimeout(() => {
        this.$nextTick(this.setRows());
      }, 1000);
    }*/
  }
};
</script>

<style scoped>
.products {
  grid-template-columns: repeat(4, 277.5px);
  grid-gap: 30px;
}
@media screen and (max-width: 1240px) {
  .container {
    max-width: 1024px !important;
  }
  .products {
    grid-template-columns: repeat(3, 328px);
    grid-gap: 25px;
  }
}
@media screen and (max-width: 1040px) {
  .container {
    max-width: 768px !important;
  }
  .products {
    grid-template-columns: repeat(3, 246px);
    grid-gap: 25px;
  }
}
@media screen and (max-width: 980px) {
  .grid__col--4 {
    grid-template: 1fr / repeat(3, 1fr);
    margin-top: 30px;
  }
  .grid__col--5 {
    grid-template: 1fr / repeat(4, 1fr);
  }
}
@media screen and (max-width: 800px) {
  .container {
    max-width: 595px !important;
  }
  .products {
    grid-template-columns: repeat(2, 282.5px);
    grid-gap: 20px;
  }
}
@media screen and (max-width: 768px) {
  .grid__col--4 {
    grid-template: 1fr / repeat(2, 1fr);
  }
  .grid__col--5 {
    grid-template: 1fr / repeat(3, 1fr);
    grid-gap: 20px 10px;
  }
  .grid__1--3 {
    grid-template: 1fr / 1.5fr 3.5fr;
  }
}
@media screen and (max-width: 595px) {
  .grid__col--5 {
    grid-template: 1fr / repeat(2, 1fr);
    grid-gap: 20px 10px;
  }
  .grid__col--4 {
    grid-template: 1fr / repeat(1, 1fr);
  }
  .grid__1--3 {
    grid-template: 1fr / 1fr;
    grid-gap: 10px;
  }
}
@media screen and (max-width: 620px) {
  .container {
    max-width: 300px !important;
  }
  .products {
    grid-template-columns: 1fr;
    grid-gap: 25px;
  }
}
</style>
